import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Share } from '@/components/Share/Share';
import { EntityType, Hcphco } from '@/core/graphql/generated/types';

import { DcrControl } from '../DcrControl/DcrControl';
import { ReactivateDcrControl } from '../ReactivateDcrControl/ReactivateDcrControl';

import { profilePageHeaderStyles as sx } from './ProfilePageHeader.styles';

type Props = {
	profile: Hcphco | null;
	loading: boolean;
};

export const ProfilePageHeader = ({ profile, loading }: Props) => {
	const { t } = useTranslation();

	return (
		<Box display='flex' flexDirection='column' px={2} pt={2} gap={1}>
			<Box
				display='flex'
				flexDirection='row'
				justifyContent={'space-between'}
				alignItems={'center'}
			>
				<Typography sx={sx.typeLabel} variant='body1'>
					{profile?.__typename === 'HCP' ? t('HCP') : t('HCO')}
				</Typography>

				<Box gap={1.5} display='flex' flexDirection='row' alignItems='center'>
					{profile && profile?.statusCda_VId !== 'iact' && (
						<DcrControl
							loading={loading}
							entityType={
								profile?.__typename === 'HCP' ? EntityType.Hcp : EntityType.Hco
							}
						/>
					)}

					{profile && profile?.statusCda_VId === 'iact' && (
						<ReactivateDcrControl
							profile={profile}
							entityType={
								profile?.__typename === 'HCP' ? EntityType.Hcp : EntityType.Hco
							}
						/>
					)}

					<Share
						title={t('Share this profile')}
						description={t(
							'Copy and paste the link above to share this profile.'
						)}
					/>
				</Box>
			</Box>
		</Box>
	);
};
